module.exports = __webpack_public_path__ + "img/modelx_top_view.edf46922.jpg";